import PerformanceByTerritoryCard from "../PerformanceByTerritory/PerformanceByTerritoryCard";
import {
  PERFORMANCE_BENCHMARK_TOOLTIP_TEXT,
  REGIONAL_PERFORMANCE_TEXT,
} from "../PerformanceByTerritory/performanceTextConstants";

export default function RegionalTerritoryPerformanceCard({
  rows = [],
  isLoading = false,
  onExplore,
}) {
  return (
    <PerformanceByTerritoryCard
      title={REGIONAL_PERFORMANCE_TEXT.title}
      titleTooltipText={PERFORMANCE_BENCHMARK_TOOLTIP_TEXT}
      subtitle={REGIONAL_PERFORMANCE_TEXT.subtitle}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
    />
  );
}
